// extracted by mini-css-extract-plugin
export var container = "_4y-0";
export var error = "_4y-9";
export var label = "_4y-5";
export var light = "_4y-6";
export var md = "_4y-3";
export var sm = "_4y-2";
export var thin = "_4y-8";
export var thinBold = "_4y-7";
export var vertical = "_4y-4";
export var xs = "_4y-1";